import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { howItWorks } from "@/mocks/siteData";

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="sun-glaze bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-2xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              From Farm to Experience
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            How It Works
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4">
          {howItWorks.map((item, index) => (
            <Reveal key={item.step} delay={index * 90}>
              <div className="relative h-full bg-background-50 rounded-lg border border-background-200 p-6 flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-4xl text-background-300 font-semibold leading-none">
                    {item.step}
                  </span>
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                </div>
                <h3 className="font-heading text-xl text-foreground-950 font-semibold mt-5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-2.5 flex-1">
                  {item.text}
                </p>
                {index < howItWorks.length - 1 && (
                  <i className="ri-arrow-right-down-line absolute -right-3 top-1/2 text-accent-400 hidden md:block"></i>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}